module.exports = __webpack_public_path__ + "static/media/andarbahar-banner.9322a060.svg";